export const usersKeys = {
  all: ["users"] as const,
  me: () => [...usersKeys.all, "me"] as const,
  checkUsername: (username: string) => [...usersKeys.all, "checkUsername", username] as const,
}
